import { createSlice } from "@reduxjs/toolkit";

import {
  fetchBooks,
  fetchBookChapters,
} from "./book.thunk";

const initialState = {
  books: [],
  chapters: [],
  loading: false,
  error: null,
};

const bookSlice = createSlice({
  name: "book",

  initialState,

  reducers: {
    clearBooks: (state) => {
      state.books = [];
    },

    clearBookChapters: (state) => {
      state.chapters = [];
    },

    clearBookData: (state) => {
      state.books = [];
      state.chapters = [];
      state.error = null;
    },
  },

  extraReducers: (builder) => {
    builder

      /* ============================================================
         FETCH BOOKS
      ============================================================ */

      .addCase(fetchBooks.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchBooks.fulfilled, (state, action) => {
        state.loading = false;
        state.books = action.payload.data || [];
      })

      .addCase(fetchBooks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.books = [];
      })

      /* ============================================================
         FETCH BOOK CHAPTERS
      ============================================================ */

      .addCase(fetchBookChapters.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchBookChapters.fulfilled, (state, action) => {
        state.loading = false;
        state.chapters = action.payload.data || [];
      })

      .addCase(fetchBookChapters.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.chapters = [];
      });
  },
});

export const {
  clearBooks,
  clearBookChapters,
  clearBookData,
} = bookSlice.actions;

export default bookSlice.reducer;